import React from "react"
import { motion } from "framer-motion"
import { ImageHand } from "../components/gatsby-image/hand-images"
import PopUp from "../components/typeform"

import { stagger, fadeUp, ease } from "../utils/animations"

const HeroUI = ({ src, heading, description, buttonText }) => {
  return (
    <>
      <motion.div
        className="hero-cnt"
        variants={staggerFade}
        initial="initial"
        animate="animate"
      >
        <div className="hero margin">
          
          <motion.div className="heading-cnt" variants={stagger}>
            <motion.div className="heading" variants={fadeUp}>
              <h1>{heading}</h1>
            </motion.div>
            <motion.p className="intro-text" variants={fadeUp}>
              {description}
            </motion.p>
            <motion.div variants={fadeUp}>
              <PopUp>
                <button>{buttonText}</button>
              </PopUp>
            </motion.div>
          </motion.div>

          <motion.div className={`hero-hand ${src}`} variants={moveUp} >
            <ImageHand src={src} />
          </motion.div>
        </div>
      </motion.div>
    </>
  )
}

export default HeroUI

const staggerFade = {
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: { duration: 1, staggerChildren: .8, delayChildren: .7 },
  },
}

const moveUp = {
  initial: { y: "120%", rotate: "5deg", x: "-500px", opacity: 0, scaleX: "-1" },
  animate: { y: 0, x: 0, rotate: "-20deg", opacity: 1, transition: {duration: .7, type: "spring",
  damping: 13} },
}
